import { OnboardingPlanDisplay } from '../types';

const hasDiscount = (plan: OnboardingPlanDisplay): boolean =>
  Boolean(plan.providerPackageId && plan.discountPrice !== plan.price);

export default hasDiscount;
